import { NavBar } from 'antd-mobile';
import { Text } from 'farmhub-ui-core';
import styled from 'styled-components';

import { ArrowLeftIcon } from 'components/Icon';
import { theme } from 'styled';

interface NavbarMobileProps {
  style?: any;
  title?: string;
  children?: any;
  handleRight?: any;
  isShow?: boolean | undefined;
  isShowArrow?: boolean | undefined;
  handleBack?: (() => void) | undefined;
  onCloseSearch?: () => void | undefined;
}

export const NavbarMobile = ({
  isShow,
  style,
  title,
  children,
  handleRight,
  isShowArrow = true,
  onCloseSearch,
  handleBack = () => history.back(),
}: NavbarMobileProps): JSX.Element => (
  <WrapperNavbar style={style}>
    <CartNavBar
      backArrow={
        isShowArrow && <ArrowLeftIcon color="#FFFFFF" height={18} width={18} />
      }
      right={handleRight}
      style={{ padding: `0 ${theme.app.padding.horizontal}` }}
      onBack={handleBack}
    >
      {title ? (
        <Text color="white" weight="bold">
          {title}
        </Text>
      ) : (
        children
      )}
    </CartNavBar>
    {/* <PopupSearch {...{ isShow, onCloseSearch }} /> */}
  </WrapperNavbar>
);

export const NavbarAccountMobile = ({
  children,
  handleBack = () => history.back(),
  handleRight,
  isShow,
  isShowArrow = true,
  onCloseSearch,
  style,
  title,
}: NavbarMobileProps): JSX.Element => (
  <WrapperNavbar style={style}>
    <CartNavBar
      backArrow={
        isShowArrow && <ArrowLeftIcon color="#FFFFFF" height={18} width={18} />
      }
      right={handleRight}
      style={{ padding: '0 18px' }}
      onBack={handleBack}
    >
      {children}
    </CartNavBar>
    {/* <PopupSearch {...{ isShow, onCloseSearch }} /> */}
  </WrapperNavbar>
);

const WrapperNavbar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 200;
  height: 50px;
  width: 100%;
`;

export const CartNavBar = styled(NavBar)`
  width: 100%;
  color: #fff;
  background: ${p => p.theme.colors.primary.main};
  height: 50px !important;

  .adm-nav-bar-title {
    font-size: 14px;
    font-weight: ${p => p.theme.font.weight.extraBold} !important;
  }

  .adm-nav-bar-back-arrow {
    display: flex;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .adm-nav-bar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
